import axios from "axios";
import { config } from "../../config/appConfig";
import { globalApiHandler } from "../../services/services";

export const USER = {
  subscriptionList: {
    success: "SUBSCRIPTION_SUCCESS"
  },
  subscriptionPlan: {
    started: "SUBSCRIPTION_STARTED",
    success: "SUBSCRIPTION_POST",
    error: "SUBSCRIPTION_FAILED"
  },
  getUserTokenDetails: {
    success: "UNIQUE_TOKEN_POST",
    error: "UNIQUE_TOKEN_ERROR"
  },
  login: {
    error: "USER_LOGIN_FAILED"
  },
  cancelSubscription: {
    start: "CANCEL_SUBSCRIPTION_START",
    success: "CANCEL_SUBSCRIPTION_SUCCESS"
  }
};

export const getSubscriptionPlan = () => {
  let url = `${config.BASE_URL}/ntrac/subscription/subscriptionList`;
  return dispatch => {
    axios
      .get(url)
      .then(response => {
        dispatch({
          type: USER.subscriptionList.success,
          data: response.data.data
        });
        return true;
      })
      .catch(err => {
        err => dispatch({ type: "LOAD_DATA_FAILURE", err });
      });
  };
};

export const cancelSubscriptionPlan = userEmail => {
  const url = `/ntrac/makePayment/cancelSubscription?username=${userEmail}`;

  return dispatch => {
    dispatch({ type: USER.cancelSubscription.start });
    globalApiHandler(url, "post", {})
      .then(response => {
        const userProfileUrl = `/ntrac/user/${userEmail}/`;
        globalApiHandler(userProfileUrl, "get", {}).then(response => {
          localStorage.setItem(
            "userProfile",
            JSON.stringify(response.data.data)
          );
          dispatch({ type: USER.cancelSubscription.success, data: true });
        });
        console.log(response);
      })
      .catch({});
  };
};

export const getUserTokenDetails = uniqueToken => {
  let url = `${config.BASE_URL}/ntrac/user/verifySignedupUser/${uniqueToken}`;
  return dispatch => {
    axios
      .get(url)
      .then(response => {
        //resposnse token verify   & user detail
        const data = response.data.data;
        dispatch({ type: USER.getUserTokenDetails.success, data });
        dispatch({ type: USER.login.error, data: "" });
      })
      .catch(err => {
        dispatch({ type: USER.getUserTokenDetails.error, data: err.response });
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const postSubscriptionPlan = (userName, planId, subscriptionPlan) => {
  let url = `${config.BASE_URL}/ntrac/subscribe/${userName}/${planId}/`; //get url in response
  return dispatch => {
    let data = "";
    dispatch({ type: USER.subscriptionPlan.started, data });
    axios
      .post(url, {})
      .then(response => {
        const data = response.data;
        dispatch({ type: USER.subscriptionPlan.success, data });
        dispatch({ type: "USER_LOGIN_FAILED", data: {} });
        //dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({
          type: USER.subscriptionPlan.error,
          data: err.response.data.message
        });
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/subscription/action.js